export default "__VITE_ASSET__25f7079e__"